<template>
    <div class="main main--hasHeader main--hasFooter">
      <div class="top">
        <div class="fullContainer">
          <div style="text-align: right;padding-top: 2rem;">
            <a href="#" @click="setLang('en')" v-if="app_lang_type == 'ja'" class="btn btn-lg btn-outline-secondary">ENGLISH</a>
            <a href="#" @click="setLang('ja')" v-if="app_lang_type == 'en'" class="btn btn-lg btn-outline-secondary">日本語</a>
            <!-- {{ currentDate.drive.format("YYYY-MM-DD") }} -->
          </div>
        </div>
        <div class="fullContainer" v-if="member_code_sw">
            <card-view 
            @to_click_event="member_code_switch_action" 
            @to_click_reflesh="member_code_reflesh" 
            :memberData="getMyData" :dispDashboard="true"></card-view>
        </div>
        <div class="fullContainer" v-else>
          <p class="top__mv py-3">&nbsp;</p>
        </div>
        <div class="customContainer" v-if="!member_code_sw">
          <p class="top__cardShow"><a class="button01" href="#" @click="member_code_switch_action('open')">{{ word_chg('会員証を表示')}}</a></p>
        </div>
        <!-- <a @click="testtest()" class="btn btn-light">test{{ word_chg('日付') }}</a> -->
        <div class="customContainer" style="padding-bottom:3.4771192798rem;">
          <p class="top__checkIn" v-if="getMyData && getMyData.checkin">
            <router-link class="top__checkInLink" to="/user/checkin">
              <span class="top__checkInTitle">Check in</span>
              <span class="top__checkInDate">{{ getMyData.checkin.checkin_date_label }}</span>
            </router-link>
          </p>
        </div>
        <!-- {{ getMyData.barcode_param }} -->

        <information-list v-if="false"></information-list>
        <event-list v-if="vue_node_env!='production'"></event-list>
        <!-- {{ getReserved_count }} -->
        <div class="customContainer" v-if="getReserved_count > 0">
          <h2 class="top__h201">RESERVED</h2>
          <p class="top__reserveOptionMore" style="margin-bottom: 1rem;">{{ word_chg('以下のご予約を承っております') }}</p>
          <ul class="top__reserveCards">
            <li class="top__reserveCard top__reserveCard--border" v-if="getReserved_type('drive').length > 0">
              <div class="topReserveCard topReserveCard--blue mb-2" v-for="reserved in getReserved_type('drive')" :key="reserved">
                <router-link class="topReserveCard__link d-flex align-items-center" to="/reserved/drive">
                  <p class="topReserveCard__type d-flex align-items-center justify-content-center" style="width:7.6rem;">
                    {{ word_chg('走行') }}</p>
                  <div class="topReserveCard__right">
                    <p class="topReserveCard__date">
                      {{ reserved.start_date_str }} {{ youbi(reserved) }}
                      <span v-for="(item, index) in reserved.item_data" :key="item">
                          <!-- {{ item }} -->
                          {{ item.start_time_str }} - {{ item.end_time_str }}
                          <span v-if="(parseInt(index)+1) < Object.keys(reserved.item_data).length">/</span>
                      </span>
                    </p>
                    <p class="topReserveCard__name">{{reserved.label}} </p>
                  </div>
                </router-link>
              </div>
            </li>
            <li class="top__reserveCard" v-if="getReserved_type('lodge').length > 0">
              <div class="topReserveCard topReserveCard--pink mb-2"  v-for="reserved in getReserved_type('lodge')" :key="reserved">
                <router-link class="topReserveCard__link d-flex align-items-center" to="/reserved/lodging">
                  <p class="topReserveCard__type d-flex align-items-center justify-content-center" v-html="word_chg_html('宿泊')" style="width:7.6rem;"></p>
                  <div class="topReserveCard__right">
                    <p class="topReserveCard__date">{{ reserved.start_date_str }} {{ youbi(reserved) }}</p>
                    <p class="topReserveCard__name">{{reserved.label}} </p>
                  </div>
                </router-link>
              </div>
            </li>
            <li class="top__reserveCard" v-if="getReserved_type('facility').length > 0">
              <div class="topReserveCard topReserveCard--green mb-2"  v-for="reserved in getReserved_type('facility')" :key="reserved">
                <router-link class="topReserveCard__link d-flex align-items-center" to="/reserved/facility">
                  <p class="topReserveCard__type d-flex align-items-center justify-content-center" v-html="word_chg_html('施設')" style="width:7.6rem;"></p>
                  <div class="topReserveCard__right">
                    <p class="topReserveCard__date">{{ reserved.start_date_str }} {{ youbi(reserved) }}</p>
                    <p class="topReserveCard__name">{{reserved.label}} </p>
                  </div>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
        <div class="customContainer" v-else>
          <h2 class="top__h201">RESERVED</h2>
          <p class="top__noReserve">--</p>
        </div>
        <div class="customContainer" style="margin-bottom: 4rem;">
          <h2 class="top__h201">PROGRAM</h2>
          <div class="members-menu__list">
            <ul>
              <!-- <li v-if="app_lang_type == 'ja'">
                <a :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_' + app_lang_type + '.23.8.23.pdf'" target="_blank">
                  {{ word_chg('走行プログラム詳細') }}
                </a>
              </li>
              <li v-else>
                <a :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_' + app_lang_type + '.23.8.17.pdf'" target="_blank">
                  {{ word_chg('走行プログラム詳細') }}
                </a>
              </li> -->
              <!-- <li v-if="app_lang_type == 'ja'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_schedule_' + app_lang_type + '.23.10.11.pdf'" 
                  v-if="date_check_sw"
                  target="_blank">
                  {{ word_chg('走行スケジュール') }}
                </a>
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_schedule_' + app_lang_type + '.23.9.1.pdf'" 
                  v-else
                  target="_blank">
                  {{ word_chg('走行スケジュール') }}
                </a>
              </li>
              <li v-else>
                <a :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_schedule_' + app_lang_type + '.23.9.1.pdf'" target="_blank">
                  {{ word_chg('走行スケジュール') }}
                </a>
              </li> -->
              <li>
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_' + app_lang_type + '.24.6.4.pdf'" 
                  target="_blank">
                  {{ word_chg('ドライビングプログラム') }}
                </a>
              </li>
              <!-- <li v-if="app_lang_type == 'ja'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_price_2401_' + app_lang_type + '.24.1.16.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2401-02') }}
                </a>
              </li>
              <li v-else>
                <a :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_price_2401_' + app_lang_type + '.24.1.16.pdf'" target="_blank">
                  {{ word_chg('走行料金カレンダー2401-02') }}
                </a>
              </li> -->
              <!-- <li>
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwfile/fee_calendar_2406_' + app_lang_type + '.06.03.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2406') }}
                </a>
              </li> -->
              <!-- <li>
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwfile/fee_calendar_2407_' + app_lang_type + '.24.07.11.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2407') }}
                </a>
              </li> -->
              <!-- <li>
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwfile/fee_calendar_2408_' + app_lang_type + '.24.07.11.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2408') }}
                </a>
              </li> -->
              <!-- <li v-if="app_lang_type == 'ja'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20240828124257_VXVNVNZ2FXIUZ.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2409') }}
                </a>
              </li>
              <li v-else-if="app_lang_type == 'en'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20240828124300_87SWZFCPMQ7WC.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2409') }}
                </a>
              </li> -->

              <!-- <li v-if="app_lang_type == 'ja'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20240919160925_78ILTIP6Y88ZW.png'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2410') }}
                </a>
              </li>
              <li v-else-if="app_lang_type == 'en'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20240919160944_MDQBIREXGJHDP.png'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2410') }}
                </a>
              </li> -->
              <!-- <li v-if="app_lang_type == 'ja'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20240919161221_XX85IXX8UJ4RZ.png'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2411') }}
                </a>
              </li>
              <li v-else-if="app_lang_type == 'en'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20240919160949_38D96W7IC2XFZ.png'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2411') }}
                </a>
              </li> -->
              <li v-if="app_lang_type == 'ja'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20240919160937_49U65NLINCZAF.jpg'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2412') }}
                </a>
              </li>
              <li v-else-if="app_lang_type == 'en'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20240919160955_V6DDSKUXHIL2P.jpg'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2412') }}
                </a>
              </li>
              <li v-if="app_lang_type == 'ja'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20241207085307_FHG97NRPW5DU3.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2501') }}
                </a>
              </li>
              <li v-else-if="app_lang_type == 'en'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20241207085310_PZ2R12KEM4NPJ.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2501') }}
                </a>
              </li>
              <li v-if="app_lang_type == 'ja'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20241213160209_FZER1CBRD4ZCJ.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2502') }}
                </a>
              </li>
              <li v-else-if="app_lang_type == 'en'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwapi/assets/uploadfile/mgw/20241213160212_FYC7M3WEG1R7F.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2502') }}
                </a>
              </li>
              <!-- <li v-if="app_lang_type == 'ja'">
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_price_2403_' + app_lang_type + '.24.2.1.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2403-05') }}
                </a>
              </li>
              <li v-else>
                <a :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_price_2403_' + app_lang_type + '.24.2.1.pdf'" target="_blank">
                  {{ word_chg('走行料金カレンダー2403-05') }}
                </a>
              </li>
              <li>
                <a 
                  :href="'https://www1.ms-event.net/mgcweb/mgwfile/drive_program_price_2406_' + app_lang_type + '.24.04.22.pdf'" 
                  target="_blank">
                  {{ word_chg('走行料金カレンダー2406-08') }}
                </a>
              </li> -->
            </ul>
          </div>
        </div>
        <!-- <form action="" method="POST"> -->
        <div class="customContainer">
          <h2 class="top__h201">CALENDAR</h2>
          <p :class="tabDisplay('drive') + ' top__reserveOptionMore'" style="margin-bottom: 1rem;">{{word_chg('走行を予約する')}}</p>
          <p :class="tabDisplay('lodging') + ' top__reserveOptionMore'" style="margin-bottom: 1rem;">{{word_chg('宿泊予約をする')}}</p>
          <p :class="tabDisplay('facility') + ' top__reserveOptionMore'" style="margin-bottom: 1rem;">{{word_chg('施設の予約をする')}}</p>
          <ul class="top__reserveTypes d-flex">
            <li class="top__reserveType">
              <a :class="tab_switch('drive')" @click="tab_switch_action('drive')" >
              {{ word_chg('走行') }}</a>
            </li>
            <li class="top__reserveType">
              <a :class="tab_switch('lodging')" @click="tab_switch_action('lodging')" >{{ word_chg('宿泊') }}</a>
            </li>
            <li class="top__reserveType">
              <a :class="tab_switch('facility')" @click="tab_switch_action('facility')" >{{ word_chg('施設') }}</a>
            </li>
          </ul>
          <div class="top__reserveOptions">
            <div :class="tabDisplay('facility')" v-if="mgw_phase_production_001">
              
            </div>
            <div :class="tabDisplay('facility')" v-else>
              <div class="d-none" style="margin-bottom: 2rem;">
                <p class="top__reserveOptionMore" style="text-align: center;">施設を選択してください</p>
              </div>
              <div class="d-flex align-items-center">
                <div class="top__reserveOptionInput" style="width: 100%;">
                  <bs-select
                    :name="'facility_group_id'"
                    :options="node_category_group_facility"
                    v-model="facility_group_id"
                    :null-option="true"
                    id="ReserveFacilityGroupId"
                    class="top__reserveOptionSelect"
                  ></bs-select>
                </div>
              </div>
            </div>

            <div :class="tabDisplay('facility')">
              <calendar-view
                v-if="[8,9,10].includes(parseInt(facility_group_id))"
                :loading-finish-obj="loadingFinish['facility']"
                :selectMode="'facility'"
                :dateDataObj="dateDate_facility_sort_by_group"
                :selectDateObj="selectDate"
                :consecutive_cnt="this.facility_consecutive_cnt"
                :currentDateObj="currentDate['facility']"
                @set_current_date="setCurrentDateFacility"
                @to_push_select_date="pushSelectDateToFacility"
              >
              </calendar-view>
              <facility-view
                v-else
                :search_disp_sw="false"
                :facility_group_id_obj="facility_group_id"
              ></facility-view>
              <p class="text-center">
                <a href="mailto:reservation@club.magarigawa.com" class="py-2">reservation@club.magarigawa.com</a><br>
                <a href="tel:0470-29-3555" class="py-2">0470-29-3555</a>
              </p>
            </div>

            <div :class="tabDisplay('lodging')" v-if="true">
              
            </div>
            <div :class="tabDisplay('lodging')" v-else>
              <div class="d-flex align-items-center">
                <div class="top__reserveOptionLabel">
                  <label>泊数</label>
                </div>
                <div class="top__reserveOptionInput">
                  <bs-select
                    :name="'consecutive_cnt'"
                    :options="reserve_stay_num"
                    v-model="consecutive_cnt"
                    :null-option="false"
                    id="ReserveConsecutiveCnt"
                    class="top__reserveOptionSelect"
                  ></bs-select>
                </div>
              </div>
            </div>
            <div :class="tabDisplay('lodging')">
              <calendar-view
                :selectMode="'lodge'"
                :loading-finish-obj="loadingFinish['lodge']"
                :dateDataObj="dateDate_lodge"
                :selectDateObj="selectDate"
                :consecutive_cnt="this.consecutive_cnt"
                :currentDateObj="currentDate['lodge']"
                @set_current_date="setCurrentDateLodge"
                @to_push_select_date="pushSelectDateToLodge"
              >
              </calendar-view>
            </div>
            <div :class="tabDisplay('drive')" v-if="false">
              <div class="d-flex align-items-center">
                <div class="top__reserveOptionLabel">
                  <label>{{word_chg('走行人数')}}</label>
                </div>
                <div class="top__reserveOptionInput">
                  <bs-select
                    :name="'reserve_num'"
                    :options="reserve_num_list"
                    v-model="reserve_num"
                    :null-option="false"
                    id="ReserveNum"
                    class="top__reserveOptionSelect"
                  ></bs-select>
                </div>
              </div>
              <!-- <p class="top__reserveOptionMore"><a @click="pushReserveDetail('drive')">詳細な条件で検索する場合はこちら</a></p> -->
            </div>
            <div :class="tabDisplay('drive')">
              <calendar-view
                :selectMode="'drive'"
                :loading-finish-obj="loadingFinish['drive']"
                :dateDataObj="dateDate_drive"
                :selectDateObj="selectDate"
                :reserve_num="this.reserve_num"
                :currentDateObj="currentDate['drive']"
                @set_current_date="setCurrentDateDrive"
                @to_push_select_date="pushSelectDateToDrive"
              >
              </calendar-view>
            </div>

          </div>
        </div>

        <!-- </form> -->
      </div>
    </div>
</template>
<style>
.top__reserveTypeLink--active--lodging {
    background: #c85a8c !important;
}
.top__reserveTypeLink--active--drive {
    background: #3796c8 !important;
}
.top__reserveTypeLink--active--facility {
    background: #509646 !important;
}
</style>
<script>
import informationList from './Information/TopView.vue'
import eventList from './Event/TopView.vue'
// import driveReservedList from './Drive/ListReservedView.vue'
// import lodgingReservedList from './Lodging/ListReservedView.vue'
// import otherReservedList from './Other/ListReservedView.vue'
// import indexCalendarView from './Reservation/IndexCalendarView.vue'
import CardView from './User/CardView.vue'
import CalendarView from '../organisms/BsCalendarView.vue'
import FacilityView from './Reservation/FacilityView.vue'
import moment from "moment"
import config from '../../const'
import axios from 'axios'
import { mapState } from 'vuex'
import Common from '../../common/common'
import BsSelect from '../atoms/BsSelect.vue'
// import default from 'bootstrap'

export default {
    name: 'BsDashBoardView',
    data: function () {
        return {
            tab_active: 'drive',//or th ead
            tab_active2: 'drive',//or th ead
            currentDate: {
              drive: moment(),
              lodge: moment(),
              facility: moment(),
            },
            member_code_sw: false,
            selPaddockType: null,
            restaurant_type: 1,
            other_reservation_type: 'restaurant',
            // dashboard
            dashboard: {},
            drive_node: [],
            lodge_node: [],
            facility_node: [],
            general_node: [],
            selectDate: [],
            node_category_group: [],
            reserve_num: 1,
            consecutive_cnt: 1,
            facility_consecutive_cnt: 2,
            facility_group_id: '',
            loadingFinish: {
              drive: false,
              lodge: false,
              facility: false,
            },
        }
    },
    props: {
        displayClass: {
            type: String,
            default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        },
    },
    components: {
        informationList,
        eventList,
        CalendarView,
        FacilityView,
        BsSelect,
        // driveReservedList,
        // lodgingReservedList,
        // otherReservedList,
        // indexCalendarView,
        CardView,
    },
    mounted(){
      console.log('check page mounted!!!', this.getMyData);
      if(this.getMyData === undefined || this.getMyData === 'undefined' || this.getMyData === 'false' || this.getMyData === false){
      console.log('check page getMyData!!! logout');
        this.$router.push({ path: '/logout' });
      }
      else if(this.getMyData.checkin){
        this.member_code_sw = true;
      }
    },
    methods: {
      setLang(lang){
        console.log('setLang', lang);
        this.$store.dispatch('setLangType', {data: lang});
        this.$router.go({ path: '/', force: true });
      },
      testtest(){
        console.log('testtest');
        this.langTest();
      },
      async setCurrentDateType(date, type){
        const c_date = {...this.currentDate};
        if(
          typeof c_date === 'object' 
        ){
          c_date[type] = date;
          this.currentDate = c_date;
        }

        await this.loadNode(type);
      },
      async setCurrentDateDrive(date){
        await this.setCurrentDateType(date, 'drive');
      },
      async setCurrentDateLodge(date){
        await this.setCurrentDateType(date, 'lodge');
      },
      async setCurrentDateFacility(date){
        await this.setCurrentDateType(date, 'facility');
      },
      pushReserveDetail(type){
        this.$router.push(
          {
            name: 'reservation_' + type,
            query: {
              param_reserve_num: this.reserve_num,
              param_detail_flg: true,
              // param_category_id: ,
            }
          }
        )
      },
      pushSelectDateToDrive(date){
        // alert('予約申し込みをしました' + val);
        // const tgtDate = (typeof date === 'object')? Object.entries(date)[1]: date;
        this.$router.push(
          {
            name: 'reservation_drive',
            query: {
              param_reserve_num: this.reserve_num,
              param_date: date,
              // param_category_id: ,
            }
          });
      },
      pushSelectDateToFacility(date){
        // const tgtDate = (typeof date === 'object')? Object.entries(date)[1]: date;
        this.$router.push(
          {
            name: 'reservation_facility',
            query: {
              param_consecutive_cnt: this.facility_consecutive_cnt,
              // param_date: tgtDate,
              param_date: date,
              param_category_group_id: this.facility_group_id,
            }
          });
      },
      pushSelectDateToLodge(date){
        // alert('予約申し込みをしました' + val);
        const tgtDate = (
          typeof date === 'object' 
          && typeof Object.entries(date) === 'object' 
          && typeof Object.entries(date)[0] === 'object'
          && typeof Object.entries(date)[0][1] === 'string'
          )? Object.entries(date)[0][1]: date;
        // console.log('pushSelectDateToLodge', tgtDate, date, Object.entries(date));
        if(
          this.vue_node_env!='production'
        ){
          this.$router.push(
            {
              // name: 'reservation_plan',
              name: 'reservation_lodging',
              query: {
                param_consecutive_cnt: this.consecutive_cnt,
                param_date: tgtDate,
                // param_category_id: ,
              }
          });
        }
        else{
          this.$router.push(
            {
              name: 'reservation_lodging',
              query: {
                param_consecutive_cnt: this.consecutive_cnt,
                param_date: tgtDate,
                // param_category_id: ,
              }
          });
        }
      },
      reservation(){
          alert('予約申し込みをしました');
          this.$refs.selOtherReservationModalBClose.click();
          this.$router.push({ path: '/' })

      },
      open_restaurant_modal(){
          this.other_reservation_type = 'restaurant';
          this.$refs.selOtherReservationModalBtnR.click();
          console.log(this.$refs.selPaddockTypeModalB);
      },
      open_tennis_modal(){
          this.other_reservation_type = 'tennis';
          this.$refs.selOtherReservationModalBtnR.click();
          console.log(this.$refs.selPaddockTypeModalB);
      },
      routerMove(){
          this.$refs.selPaddockTypeModalBClose.click();
          this.$router.push({path: '/reservation/lodging', query: {from: 'dashboard'}});
      },
      open_paddock_type_modal(){
          // alert('open_paddock_type_modal');
          // $('#selPaddockTypeModalBtn').click();
          this.$refs.selPaddockTypeModalBtnR.click();
          console.log(this.$refs.selPaddockTypeModalB);
      },
      tab_switch_action(tab) {
        this.tab_active = tab;
      },
      member_code_switch_action(sw){
        if(sw == 'open'){
            this.member_code_sw = true;
        }else{
            this.member_code_sw = false;
        }
      },
      async member_code_reflesh(){
        await this.loadUser();
      },
      // calender
      // calendarPrev() {
      //   let date = moment(this.currentDate);
      //   this.currentDate = date.subtract('months', 1);
      // },
      // calendarNext() {
      //   let date = moment(this.currentDate);
      //   this.currentDate = date.add('months', 1);
      // },
      // getStartDate() {
      //     const date = moment(this.currentDate);
      //     date.startOf("month");
      //     const youbiNum = date.day();
      //     return date.subtract(youbiNum, "days");
      // },
      // getEndDate() {
      //     // console.log('getEndDate getNode');
      //     const date = moment(this.currentDate);
      //     date.endOf("month");
      //     const youbiNum = date.day();
      //     return date.add(6 - youbiNum, "days");
      // },
      // getCalendar() {
      //     let startDate = this.getStartDate();
      //     const endDate = this.getEndDate();
      //     const weekNumber = Math.ceil(endDate.diff(startDate, "days") / 7);
      //     console.log('getCalendar', startDate.year(), endDate.month(), weekNumber);

      //     let calendars = [];for (let week = 0; week < weekNumber; week++) {
      //     let weekRow = [];
      //     for (let day = 0;  day < 7; day++) {
      //         weekRow.push({
      //             month: startDate.format("YYYY-MM"),
      //             mon_num: startDate.get('month') + 1,
      //             day: startDate.get("date"),
      //         });
      //         startDate.add(1, "days");
      //         }
      //         calendars.push(weekRow);
      //     }
      //     return calendars;
      // },

      // login御
      async loadUser(){
        const params = {};
        params['id'] = this.$store.state.auth.userId;
        console.log('params', params);
        return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
        .catch((err) => {
          console.log(err);
          Promise.reject(err)
        })
        .then(() => {})
        .finally(() => {});
      },

      loadDashboard(){
        const params = {};
        // params['stat'] = [1];
        // params['financial_status'] = 10;
        const params_ = Common.createParams(params);
        axios.post(
            config.BASE_API_URL + '/user/dashboard',
            params_,
            {
            headers: this.axiosHeader
            }
        )
        .then(
            (response) => {
              this.dashboard = response.data.body;
              console.log('then dashboard', response);
              if(this.dashboard.drive_node) this.drive_node = this.dashboard.drive_node;
              if(this.dashboard.lodge_node) this.lodge_node = this.dashboard.lodge_node;
              if(this.dashboard.facility_node) this.facility_node = this.dashboard.facility_node;
              if(this.dashboard.node_category_group) this.node_category_group = this.dashboard.node_category_group;
            }
        )
        .catch((err) => {
            console.log('loadDashboard err c', err);
            // this.search_sales = [];
        })
        .finally(() => {
            console.log('finally dashboard', this.dashboard);
            // this.loadingFinish = true;
            this.$forceUpdate();
        });

      },
      async loadNodeCategory(){
        const params = {};
        params['stat'] = 1;
        const params_ = Common.createParams(params);

        await axios.post(
            config.BASE_API_URL + '/node_category_group/lists',
            params_,
            {
            headers: this.axiosHeader
            }
        )
        .then(
            (response) => {
              this.node_category_group = response.data.body;
            }
        )
        .catch((err) => {
            console.log('loadDashboard err c', err);
            // this.search_sales = [];
        })
        .finally(() => {
            // this.loadingFinish[type] = true;
            this.$forceUpdate();
        });

      },
      async loadNode(type){
        this.loadingFinish[type] = false;
        const params = {};
        params['node_type'] = type;
        params['type'] = type;
        params['stat'] = [1];
        // params['reserved_count'] = 0;
        params['is_owner'] = 0;
        // if(this.sprm.category_group_id) params['category_ids'] = this.node_category_group_category_ids(this.sprm.category_group_id);
        params['range_start_date'] = this.currentDate[type].format('YYYY-MM-') + '01';
        params['range_end_date'] = moment(this.currentDate[type]).endOf('month').format('YYYY-MM-DD');
        params['consecutive_cnt'] = this.consecutive_cnt;
        const now_date = moment().format('YYYY-MM-DD HH:mm:ss');
        params['release_start_date'] = now_date;
        params['release_end_date'] = now_date;
        params['accept_start_date'] = now_date;
        params['accept_end_date'] = now_date;
        const params_ = Common.createParams(params);
        console.log('loadNode params', params);

        await axios.post(
            config.BASE_API_URL + '/node/lists',
            params_,
            {
            headers: this.axiosHeader
            }
        )
        .then(
            (response) => {
        console.log('loadNode response', response);
              if(type=='drive'){
                this.drive_node = response.data.body;
              }
              else if(type == 'lodge'){
                this.lodge_node = response.data.body;
              }
              else if(type == 'facility'){
                this.facility_node = response.data.body;
              }
        //       const tmps = {...this.dashboard}
        //       if(tmps[type + '_node']) tmps[type + '_node'] = response.data.body;
        // console.log('loadNode tmps', tmps);
        //       this.dashboard = tmps;
        // console.log('loadNode dashboard', this.dashboard);
            }
        )
        .catch((err) => {
            console.log('loadDashboard err c', err);
            // this.search_sales = [];
        })
        .finally(() => {
            this.loadingFinish[type] = true;
            this.$forceUpdate();
        });

      }
    },
    async created () {
      console.log('check page created!!!');
      await this.loadUser();
      // this.loadDashboard();
      // this.load
      await this.loadNode('drive');
      await this.loadNode('lodge');
      await this.loadNode('facility');
      await this.loadNodeCategory();
      // this.sel_month = this.month_list[12].key;
    },
    computed: {
      ...mapState({
        user: state => state.apidata.user,
        set_lang: state => state.apidata.set_lang,
      }),
      date_check_sw: function(){
        const chk_date = '202310121000';
        if(parseInt(chk_date) <= parseInt(moment().format('YYYYMMDDHHmm'))){
          return true;
        }
        return false;
      },
      app_lang_type: function (){
            // console.log('com')
            if(this.set_lang){
                return this.set_lang;
            }
            else{
                return this.$store.state.auth.app_lang_type;
            }
      },
      youbi: function (){
          return function(node){
              return moment(node.start_date_str).format("ddd");
          }
      },
      // login user
      getMyData: function(){
        const mydata = this.user.find((data) => {
          return data.id == this.$store.state.auth.userId;
        });
        console.log('getMyData', mydata);
        return mydata;
      },
      getReserved: function(){
        return (typeof this.dashboard === 'object' && typeof this.dashboard.reserved === 'object')? this.dashboard.reserved: [];
      },
      getReserved_type: function(){
        const reserved = (typeof this.dashboard === 'object')? this.dashboard.reserved: false;
        return function (type){
          console.log('getReserved_type', type, reserved);
          if(typeof reserved === 'object' && reserved[type + '_node']){
            return reserved[type + '_node'];
          }else{
            return [];
          }
        }
      },
      getReservedTypeColor: function(){
        return function (type){
          if(type == 'lodge'){
            return 'pink';
          }
          else if(type == 'drive'){
            return 'blue';
          }
          else {
            return 'green';
          }
        }
      },
      getReserved_count: function(){
        let cnt = 0;
        if(typeof this.getReserved === 'object'){
          Object.values(this.getReserved).forEach(reserved => {
            reserved.map(res_n => {
              if(res_n.stat == 1){
                cnt++;
              }
            })
            // cnt = cnt + (typeof reserved === 'object')? Object.keys(reserved).length: 0;
          });
        }
        return cnt;
      },
      axiosHeader: function(){
          return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
      },

      // calendar object
      dateDate_drive: function(){
        return this.drive_node;
      },
      dateDate_lodge: function(){
        return this.lodge_node;
      },
      dateDate_facility: function(){
        return this.facility_node;
      },
      dateDate_facility_sort_by_group: function(){
        const facility_node = this.dateDate_facility;
        if(parseInt(this.facility_group_id) > 0){
          return facility_node.filter(node => parseInt(this.facility_group_id) == parseInt(node.category_group_id));
        }
        return this.facility_node;
      },

      node_category_group_facility: function(){
        return this.node_category_group.filter(grp => {
          return (grp.type == 'facility')
        });
      },


      reserve_stay_num: function(){
        const list = [];
        for(let i=2; i<=6;i++){
            list.push({
                label: i + '泊',
                key: i
            });
        }
        return list;
      },
      reserve_num_list: function(){
        const list = [];
        for(let i=1; i<=6;i++){
            list.push({
                label: i + ' ' + this.word_chg('select人'),
                key: i
            });
        }
        return list;
      },

      tabDisplay: function () {
        const self_tab_active = this.tab_active;
        return function (tab) {
            const tabClass_d = 'top__reserveOption ';
            let tabClass = 'd-none ';
            if(self_tab_active == tab){
              tabClass = 'd-block';
            }
            return tabClass_d + tabClass;
        }
      },
      tab_switch: function() {
        const self_tab_active = this.tab_active;
        return function (tab) {
            let tabClass = 'top__reserveTypeLink ';
            console.log('tab_switch', self_tab_active);
            if(self_tab_active == tab){
              tabClass += 'top__reserveTypeLink--active--' + tab;
            }
            return tabClass;
        }
      },
    }
}
</script>
